import { createContext, useContext, useState, useCallback } from "react";

const LanguageContext = createContext(null);

const UI = {
  en: {
    nav_menu: "Menu",
    nav_story: "Our Story",
    nav_events: "Events",
    nav_gallery: "Gallery",
    nav_visit: "Visit",
    order: "Order Now",
    view_menu: "View Menu",
    call: "Call",
    directions: "Get Directions",
    admin: "Admin",
    story_kicker: "The Story",
    menu_kicker: "The Menu",
    gallery_kicker: "The Bakery",
    visit_kicker: "Find Us",
    menu_title: "What we cook, every day",
    gallery_title: "Cakes for every occasion",
    visit_title: "Come say hola",
    hours: "Hours",
    phone: "Phone",
    address: "Address",
    order_intro: "Hungry now? Order for delivery or pickup.",
    cat_bakery: "Bakery & Pan Dulce",
    cat_guatemalan: "Guatemalan",
    cat_colombian: "Colombian",
    cat_pizza: "Pizzeria",
    cat_other: "More",
    rights: "All rights reserved.",
  },
  es: {
    nav_menu: "Menú",
    nav_story: "Nuestra Historia",
    nav_events: "Eventos",
    nav_gallery: "Galería",
    nav_visit: "Visítanos",
    order: "Ordenar Ahora",
    view_menu: "Ver Menú",
    call: "Llamar",
    directions: "Cómo Llegar",
    admin: "Admin",
    story_kicker: "La Historia",
    menu_kicker: "El Menú",
    gallery_kicker: "Pastelería",
    visit_kicker: "Encuéntranos",
    menu_title: "Lo que cocinamos, cada día",
    gallery_title: "Pasteles para toda ocasión",
    visit_title: "Ven a decir hola",
    hours: "Horario",
    phone: "Teléfono",
    address: "Dirección",
    order_intro: "¿Con hambre? Ordena para entrega o recoger.",
    cat_bakery: "Panadería y Pan Dulce",
    cat_guatemalan: "Guatemalteco",
    cat_colombian: "Colombiano",
    cat_pizza: "Pizzería",
    cat_other: "Más",
    rights: "Todos los derechos reservados.",
  },
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState("es");
  const toggle = useCallback(() => setLang((l) => (l === "en" ? "es" : "en")), []);
  const t = (key) => UI[lang][key] ?? key;
  const pick = (obj, base) => (obj ? obj[`${base}_${lang}`] ?? obj[`${base}_es`] ?? "" : "");
  return (
    <LanguageContext.Provider value={{ lang, setLang, toggle, t, pick }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => useContext(LanguageContext);
